<div class="content-highlight-list">
  @for (item of items | async; track item) {
    <div class="item">
      @if (item.imageUrl && item.imageUrl.length > 0) {
        <div class="img-wrapper">
          <a
            class="img"
            [href]="item.link"
            target="_parent"
            [attr.aria-label]="item.title"
            [ngStyle]="getImgStyle(item.imageUrl)"
            >
          </a>
        </div>
      }
      <div class="text-wrapper">
        <a class="title" [innerHTML]="item.title"> </a>
        @if (item.description && item.description.length > 0) {
          <span
            class="description"
            [innerHTML]="item.description"
            >
          </span>
        }
      </div>
    </div>
  }
</div>
